import './spinner.scss';
const Spinner = ({ width = 24, borderWidth = 2, }) => {
	return (
		<div
			className="wds-spinner"
			style={{
				width,
				height: width,
				borderWidth,
				borderRadius: '50%'
			}}></div>
	);
};

export default Spinner;